/* Hover-видео на карточке товара в листинге.

   Разметку даёт snippets/product-grid-item.liquid: блок
   .grid-product__hover-video с <video data-src="..."> БЕЗ атрибута src —
   до первого наведения браузер не грузит ни байта видео, только poster
   (кадр-превью, который Shopify отдаёт как обычную картинку). Поэтому
   наличие 50 видео в листинге не влияет на скорость загрузки страницы.

   Делегирование на document: один обработчик на всю страницу вместо
   обработчика на карточку — работает и для карточек, догруженных
   фильтрами/пагинацией, без повторной инициализации.

   Мобильные не затрагиваются: обработчик игнорирует не-мышиные
   указатели (pointerType !== 'mouse'), а сама разметка скрыта
   классом .small--hide. */
(function () {
  'use strict';

  var currentCard = null;

  function wrapOf(card) {
    return card ? card.querySelector('.grid-product__hover-video') : null;
  }

  function start(card) {
    var wrap = wrapOf(card);
    var video = wrap && wrap.querySelector('video');
    if (!video) return;

    // src подставляем один раз, при первом наведении
    if (!video.getAttribute('src') && video.getAttribute('data-src')) {
      video.setAttribute('src', video.getAttribute('data-src'));
    }

    var played = video.play();
    // play() возвращает промис; отклонение (политики автовоспроизведения,
    // быстрый увод курсора) — штатная ситуация, не ошибка
    if (played && played.catch) played.catch(function () {});
  }

  function stop(card) {
    var wrap = wrapOf(card);
    var video = wrap && wrap.querySelector('video');
    if (!video) return;

    video.pause();
    // возвращаем на первый кадр, чтобы следующее наведение
    // начиналось с начала ролика, а не с места остановки
    try {
      video.currentTime = 0;
    } catch (e) {}
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;

      var target = event.target;
      var card = target && target.closest ? target.closest('.grid-product') : null;

      if (card === currentCard) return;

      if (currentCard) stop(currentCard);
      currentCard = null;

      if (card && wrapOf(card)) {
        currentCard = card;
        start(card);
      }
    },
    true
  );

  // курсор ушёл из окна — гасим текущее видео
  document.addEventListener('pointerleave', function () {
    if (currentCard) {
      stop(currentCard);
      currentCard = null;
    }
  });
})();
